import { render, staticRenderFns } from "./CreateButton.vue?vue&type=template&id=2eea1e10&scoped=true&"
import script from "./CreateButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CreateButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CreateButton.vue?vue&type=style&index=0&id=2eea1e10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eea1e10",
  null
  
)

export default component.exports